import auth0 from 'auth0-js';
import history from './history';
import { AUTH0_CLIENT, AUTH0_DOMAIN } from '../constants';

export default class Auth {
	auth0 = new auth0.WebAuth({
		domain: AUTH0_DOMAIN,
		clientID: AUTH0_CLIENT,
		redirectUri: `${window.location.origin}/authenticate`,
		responseType: 'token id_token',
		scope: 'openid profile email',
	});

	login() {
		this.auth0.authorize();
	}

	getProfile = (cb) => {
		this.auth0.client.userInfo(this.accessToken, (err, profile) => {
			if (profile) {
				this.userProfile = profile;
			}
			cb(err, profile);
		});
	};

	handleAuthentication = () => {
		this.auth0.parseHash((err, authResult) => {
			if (authResult && authResult.accessToken && authResult.idToken) {
				this.setSession(authResult);
			} else if (err) {
				history.replace('/');
				console.log(err);
			}
		});
	};

	getAccessToken = () => {
		return this.accessToken;
	};

	getIdToken = () => {
		return this.idToken;
	};

	setSession = (authResult) => {
		// Set isLoggedIn flag in localStorage
		localStorage.setItem('isLoggedIn', 'true');

		// Set the time that the access token will expire at
		const expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
		this.accessToken = authResult.accessToken;
		this.idToken = authResult.idToken;
		this.expiresAt = expiresAt;

		// navigate to the home route
		history.replace('/');
	};

	// renewSession = () => {
	// 	this.auth0.checkSession({}, (err, authResult) => {
	// 		if (authResult && authResult.accessToken && authResult.idToken) {
	// 			this.setSession(authResult);
	// 		} else if (err) {
	// 			this.logout();
	// 			console.log(err);
	// 		}
	// 	});
	// };

	renewSession = () => {
		return new Promise((resolve, reject) => {
			this.auth0.checkSession({}, (err, authResult) => {
				if (authResult && authResult.accessToken && authResult.idToken) {
					this.setSession(authResult);
					resolve(true);
				} else if (err) {
					console.log(err);
					this.logout();
					// eslint-disable-next-line prefer-promise-reject-errors
					reject(false);
				}
			});
		});
	};

	logout = () => {
		// Remove tokens and expiry time
		this.accessToken = null;
		this.idToken = null;
		this.expiresAt = 0;
		this.userProfile = null;

		// Remove isLoggedIn flag from localStorage
		localStorage.removeItem('isLoggedIn');

		// navigate to the home route
		history.replace('/login');
	};

	isAuthenticated = () => {
		// Check whether the current time is past the
		// access token's expiry time
		const { expiresAt } = this;
		return new Date().getTime() < expiresAt;
	};
}
